import InputCodeAndTextField from '@/components/molecules/InputCodeAndTextField/InputCodeAndTextField.vue'

export { InputCodeAndTextField }
